import React from 'react';

import styled from '@mint-lib/styled';
import AccordionDetailsM, {
  AccordionDetailsProps as AccordionDetailsPropsM,
} from '@mui/material/AccordionDetails';

export interface AccordionDetailsProps extends AccordionDetailsPropsM {
  /**
   * The content of the component.
  
   */
  children?: React.ReactNode;

  /**
   * Override or extend the styles applied to the component.
  
   */
  classes?: AccordionDetailsPropsM['classes'];

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
  
   */
  sx?: AccordionDetailsPropsM['sx'];
}

/**
 * @deprecated Use Accordion components from @mint-lib/tw-components instead
 */
function AccordionDetails(props: AccordionDetailsProps) {
  return (
    <StyledAccordionDetails {...props}>{props.children}</StyledAccordionDetails>
  );
}

export default AccordionDetails;

const StyledAccordionDetails = styled(AccordionDetailsM)<{}>({
  '&.MuiAccordionDetails-root': {
    minHeight: '0px',
  },
  borderRadius: '8px',
  padding: '12px',
});
